export default "__VITE_ASSET__emaOVKIy__"